import { CreateWarehouse } from './ui';

export { CreateWarehouse };
